import { Box, Stack } from 'braid-design-system';

import { ContactUs } from 'src/app/shared/components/ContactUs';
import { FaqSection } from 'src/app/v1/views/sections/FaqSection';

export const FaqContactSection = () => (
  <Box marginTop="xlarge">
    <Stack space="xlarge">
      <FaqSection />
      <ContactUs />
    </Stack>
  </Box>
);
